var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Button } from "../Button";
// styles
import "./drawer.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-drawerHeader",
};
const DrawerHeader = (_a) => {
    var { onClose, label, isNestedHeader, className } = _a, rest = __rest(_a, ["onClose", "label", "isNestedHeader", "className"]);
    const classList = classNames("tecma-drawerHeader", className, {
        "nested-header": isNestedHeader,
    });
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [_jsx("span", { children: label }), _jsx(Button, { className: "close-drawer-button", iconName: isNestedHeader ? "chevron-left" : "x", onClick: onClose, color: "inverse" })] })));
};
DrawerHeader.defaultProps = defaultProps;
export default React.memo(DrawerHeader);
